// #ifndefall OPEN-SOURCE
/*
 *  策略管理 policy
 */
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
import EmptyRouter from '@/layout/EmptyRouter.vue';
// import Test0Empty from '@/views/test/empty.vue';
export default {
  path: 'order',
  name: 'SettingOrder',
  component: EmptyRouterAlive,
  meta: {
    title: '订单',
  },
  children: [
    /* ******************************  暂时不显示  *******************************/
    /** 订单流程配置 */
    // {
    //   path: 'process',
    //   name: 'SettingOrderProcess',
    //   redirect: 'process/lists',
    //   component: EmptyRouter,
    //   meta: {
    //     title: '订单流程配置',
    //   },
    //   children: [
    //     {
    //       path: 'lists',
    //       name: 'SettingOrderProcessList',
    //       component: () => import('@/views/center-setting/order/process'),
    //       meta: {
    //         title: '订单流程配置',
    //       },
    //     },
    //     {
    //       path: 'view',
    //       name: 'SettingOrderProcessView',
    //       component: () => import('@/views/center-setting/order/process/view'),
    //       meta: {
    //         title: '设置订单正向流程',
    //       },
    //       hidden: true,
    //     },
    //   ],
    // },
    /** 订单流程配置end */

    /* ******************************  暂时不显示  *******************************/

    /** 订单审核策略 */
    // {
    //   path: 'audit',
    //   name: 'SettingOrderMarketingAudit',
    //   redirect: 'audit/strategy',
    //   component: EmptyRouter,
    //   meta: {
    //     title: '订单审核策略',
    //   },
    //   children: [
    //     {
    //       path: 'strategy',
    //       name: 'SettingOrderAuditStrategy',
    //       component: () => import('@/views/center-setting/order/audit/order'),
    //       meta: {
    //         title: '订单审核策略',
    //       },
    //       permissionType: 'tab',
    //       hidden: true,
    //     },
    //     {
    //       path: 'strategy/add',
    //       name: 'SettingOrderAuditStrategyAdd',
    //       component: () => import('@/views/center-setting/order/audit/order/add'),
    //       meta: {
    //         title: '新增-订单审核策略',
    //       },
    //       hidden: true,
    //     },
    //     {
    //       path: 'goods',
    //       name: 'SettingOrderAuditGoods',
    //       component: () => import('@/views/center-setting/order/audit/goods'),
    //       meta: {
    //         title: '商品行审核策略',
    //       },
    //       permissionType: 'tab',
    //       hidden: true,
    //     },
    //   ],
    // },
    /** 订单审核策略end */

    /* ******************************  暂时不显示  *******************************/
    // {
    //   path: 'preemption',
    //   name: 'SettingOrderPreemption',
    //   component: EmptyRouter,
    //   redirect: 'preemption/config',
    //   meta: {
    //     title: '预占配置',
    //   },
    //   children: [
    //     {
    //       path: 'config',
    //       name: 'SettingOrderPreemptionConfig',
    //       component: () => import('@/views/center-setting/order/preemption'),
    //       meta: {
    //         title: '预占配置',
    //       },
    //     },
    //   ],
    // },
    /** 寻源策略 */
    {
      path: 'source/strategy',
      name: 'SettingOrderSourceStrategy',
      redirect: 'source/strategy/sourcing',
      component: EmptyRouter,
      meta: {
        title: '寻源策略',
      },
      children: [
        {
          path: 'sourcing',
          name: 'SettingOrderSourceStrategySourcing',
          component: () => import('@/views/center-setting/order/source-strategy/sourcing'),
          meta: {
            title: '寻源规则',
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'parcel',
          name: 'SettingOrderSourceStrategyParcel',
          component: () => import('@/views/center-setting/order/source-strategy/parcel'),
          meta: {
            title: '包裹规则',
          },
          permissionType: 'tab',
          hidden: true,
        },
        // {
        //   path: 'area',
        //   name: 'SettingOrderSourceStrategyArea',
        //   component: () => import('@/views/center-setting/order/source-strategy/area'),
        //   meta: {
        //     title: '区域规则',
        //   },
        //   permissionType: 'tab',
        //   hidden: true,
        // },
        {
          path: '',
          name: 'SettingOrderSourceStrategyParcel_Add',
          meta: {
            title: '新增-包裹规则',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingOrderSourceStrategyParcel_Edit',
          meta: {
            title: '编辑-包裹规则',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingOrderSourceStrategyParcel_Delete',
          meta: {
            title: '删除-包裹规则',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingOrderSourceStrategyParcel_Set1',
          meta: {
            title: '排除条件设置-包裹规则',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingOrderSourceStrategyParcel_Set2',
          meta: {
            title: '包裹规则发货-包裹规则',
          },
          hidden: true,
        },
      ],
    },
    /** 寻源策略end */
    {
      path: 'source/deploy',
      name: 'SettingOrderSourceDeploy',
      component: EmptyRouter,
      redirect: 'source/deploy/config',
      meta: {
        title: '寻源配置',
      },
      children: [
        {
          path: 'config',
          name: 'SettingOrderSourceDeploy',
          component: () => import('@/views/center-setting/order/source-deploy/index'),
          meta: {
            title: '寻源配置',
          },
        },
        {
          path: '',
          name: 'SettingOrderSourceDeployConfig_Save',
          meta: {
            title: '保存-寻源配置',
          },
          hidden: true,
        },
      ],
    },
  ],
};
